"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityResultCodeMap = exports.ActivityResultCode = exports.ActivityResultCodeDefinition = void 0;
const activity_core_1 = require("@ark/activity-core");
const activity_config_1 = require("./activity.config");
exports.ActivityResultCodeDefinition = (0, activity_core_1.defineActivityErrorCodes)({
    ENROLL_ENDED: 10001,
    UDP_MISS: 10002,
    STATUS_NOT_ALLOWED: 10003,
    CHOICE_NOT_ALLOWED: 10004,
    INVALID_CHOICE: 10005,
}, { groupName: (0, activity_core_1.generateErrorGroupFromApiPrefix)(activity_config_1.activityConfig.apiPrefix) });
exports.ActivityResultCode = exports.ActivityResultCodeDefinition.enum;
exports.ActivityResultCodeMap = exports.ActivityResultCodeDefinition.map;
